document.addEventListener('DOMContentLoaded', function() {
  const addToCartForms = document.querySelectorAll('.bundle-add-to-cart');

  addToCartForms.forEach(form => {
    form.addEventListener('click', async function(e) {
      e.preventDefault();

      const shades = document.querySelectorAll('.bundle-wrapper .product-group');
      const childProducts = [];

      const bundleImage = form.querySelector('.bundle-image')?.getAttribute('value') || '';
      const bundleTitle = form.querySelector('.bundle-title')?.getAttribute('value') || '';
      const bundleUniqueId = form.querySelector('.bundle-unique-id')?.getAttribute('value') || '';

      shades.forEach(shade => {
        const productId = parseInt(shade.querySelector('.js-variant-input').getAttribute('value'));
        const shadeValue = shade.querySelector('.shade-group:not(.shade-group--hidden) .shade.swatches.selected')?.getAttribute('data-shade') || '';
        const bundleHandle = shade.querySelector('.js-variant-input-property')?.getAttribute('value') || '';

        if (productId) {
          childProducts.push({
            id: productId,
            quantity: 1,
            properties: {
              _bundle_handle: bundleHandle,
              _shade: shadeValue,
              _bundle_image: bundleImage,
              _bundle_title: bundleTitle,
              _bundle_unique_id: bundleUniqueId
            }
          });
        }
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: childProducts })
        });
      
        const text = await response.text();
      
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      
      } catch (error) {
        console.error('Fetch error:', error);
      }
      
    });
  });

  function normalizeShadeName(name) {
    return name
      .replace(/- | -| – /g, '[-SPLIT-]') 
      .split('[-SPLIT-]')                 
      .pop()                             
      .trim()                             
      .replace(/\s+/g, '-')               
      .toLowerCase();                     
  }
  
  const shadeOptions = document.querySelectorAll('.shade.swatches');

  shadeOptions.forEach(shadeOption => {
    shadeOption.addEventListener('click', function(e) {
      const shadeValue = normalizeShadeName(shadeOption.getAttribute('data-shade'));

      const productGroup = shadeOption.closest('.product-group');
      if (!productGroup) return;

      const allImages = productGroup.querySelectorAll('.product-image img');
      allImages.forEach(img => img.classList.add('hidden'));
      const targetImage = productGroup.querySelector(`.product-image img[data-shade="${shadeValue}"]`);
      if (targetImage) targetImage.classList.remove('hidden');

      const allTitles = productGroup.querySelectorAll('.product-title');
      const allDescriptions = productGroup.querySelectorAll('.description');
      allTitles.forEach(title => title.classList.add('hidden'));
      allDescriptions.forEach(desc => desc.classList.add('hidden'));
      const targetTitle = productGroup.querySelector(`.product-title[data-shade="${shadeValue}"]`);
      const targetDesc = productGroup.querySelector(`.description[data-shade="${shadeValue}"]`);
      if (targetTitle) targetTitle.classList.remove('hidden');
      if (targetDesc) targetDesc.classList.remove('hidden');

      const allSwatches = productGroup.querySelectorAll('.shade.swatches');
      allSwatches.forEach(s => s.classList.remove('selected'));
      shadeOption.classList.add('selected');

      const shadeCurrent = productGroup.querySelector('.shade-current');
      if (shadeCurrent) {
        shadeCurrent.textContent = shadeOption.getAttribute('data-shade-label') || shadeOption.getAttribute('data-shade');
      }

      const input = productGroup.querySelector('input[name="product-id"]');
      if (input) input.value = shadeOption.getAttribute('data-product-id');

      updateBundlePrice();
    });
  });

  function updateBundlePrice() {
    let totalPrice = 0;
    let totalCompareAtPrice = 0;
  
    document.querySelectorAll('.product-group').forEach(group => {
      const selected = group.querySelector('.shade.swatches.selected');
      if (!selected) return;
  
      const price = parseFloat(selected.dataset.price || 0);
      const compare = parseFloat(selected.dataset.comparePrice || 0);
  
      totalPrice += price;
      totalCompareAtPrice += compare;
    });
  
    const priceEl = document.querySelector('.bundle-price');
    const compareEl = document.querySelector('.bundle-compare-price');
  
    if (priceEl) priceEl.textContent = window.theme.formatMoney(totalPrice, window.theme.moneyFormat);

    if (compareEl && totalCompareAtPrice > totalPrice) {
      compareEl.innerHTML = `<s>${window.theme.formatMoney(totalCompareAtPrice, window.theme.moneyFormat)}</s>`;
    }
  }

});
